// import React, { useState } from "react";
// import { FaTimes } from "react-icons/fa"; // Import cross icon
// import { useDispatch } from 'react-redux';
// import { setShippingAddress ,addSavedAddress, setBillingAddress} from '../../store/addressSlice';

// const AddressPopup = ({ onClose,shippingAddress }) => {
//   const dispatch = useDispatch();
//   // Initialize the address state
//   // const [address, setAddress] = useState({
//   //   name: '',
//   //   lastName: '',
//   //   email: '',
//   //   phone: '',
//   //   saveAddressAs: '',
//   //   addressLine1: '',
//   //   addressLine2: '',
//   //   city: '',
//   //   state: '',
//   //   postalCode: '',
//   //   country: ''
//   // });
// const [address, setAddress] = useState({
//     firstName: shippingAddress?.firstName || "",
//     lastName: shippingAddress?.lastName|| "",
//     email: shippingAddress?.email || "",
//     phone: shippingAddress?.phone || "",
//     address: shippingAddress?.address|| "",
//   });
  

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setAddress({ ...address, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault(); // Prevent the default form submission behavior
//     // Dispatch the action to store the address in Redux
//     dispatch(setShippingAddress(address));
//     dispatch(setBillingAddress(address));
//     dispatch(addSavedAddress(address));
//     // dispatch(setShippingAddress(formFields));

//     // // Save address as the user's default address
//     // dispatch(addSavedAddress({ ...formFields, saveAddressAs: "Home" }));


//     onClose(); // Close the popup after saving the address
//   };
 
//   return (
//     <div className="fixed inset-0  flex items-center justify-center z-30 overflow-y-scroll">
//       <div className="bg-tertiary p-11 md:p-6 rounded md:w-[60%] relative top-24 lg:top-7">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-lg font-semibold text-center w-full">Add Address</h2>
//           <FaTimes
//             onClick={onClose}
//             className="text-xl cursor-pointer"
//           />
//         </div>
//         <hr className="mb-4" />
//         <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//           {/* Form Fields */}
//           {[{
//             label: "NAME", name: "firstName", type: "text", value: address.name,
//           }, {
//             label: "LAST NAME", name: "lastName", type: "text", value: address.lastName,
//           }, {
//             label: "E-MAIL", name: "email", type: "email", value: address.email,
//           }, {
//             label: "PHONE", name: "phone", type: "tel", value: address.phone,
//           }, {
//             label: "SAVE ADDRESS AS", name: "saveAddressAs", type: "text", value: address.saveAddressAs,
//           }, {
//             label: "HOUSE/FLAT/BLOCK NUMBER", name: "houseNumber", type: "text", value: address.houseNumber,
//           }, {
//             label: "AREA / BUILDING NAME", name: "area", type: "text", value: address.area,
//           }, {
//             label: "CITY", name: "city", type: "text", value: address.city,
//           }, {
//             label: "STATE", name: "state", type: "text", value: address.state,
//           }, {
//             label: "PINCODE", name: "pincode", type: "text", value: address.pincode,
//           }, {
//             label: "COUNTRY", name: "country", type: "text", value: address.country,
//           }].map((field, index) => (
//             <div key={index} className="-my-1">
//               <input
//                 id={field.name}
//                 name={field.name}
//                 type={field.type}
//                 value={field.value} // Use dynamic value binding
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
//                 placeholder=" "
//               />
//               <label
//                 htmlFor={field.name}
//                 className="relative left-3 px-2 bg-tertiary text-primary1 font-outfit text-sm font-medium pointer-events-none transform -translate-y-4 scale-75 bottom-[80%] z-10 origin-[0]"
//               >
//                 {field.label}
//               </label>
//             </div>
//           ))}

//           {/* Buttons in the same row */}
//           <div className="lg:col-span-2 lg:flex justify-center gap-4 -mt-2">
//             <button
//               type="submit"
//               className="w-full py-2 bg-hcolor text-tertiary hover:border-2 hover:text-hcolor hover:bg-tertiary transition"
//             >
//               UPDATE
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddressPopup;

import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setShippingAddress, addNewAddress, setBillingAddress } from "../../store/addressSlice";

const AddressPopup = ({ onClose, shippingAddress, billingAddress, isBilling = false }) => {
  const dispatch = useDispatch();

  // Initialize state with correctly named properties
  const [address, setAddress] = useState({
    user_id: localStorage.getItem("user_id") || "",
    first_name: (isBilling ? billingAddress : shippingAddress)?.first_name || "",
    last_name: (isBilling ? billingAddress : shippingAddress)?.last_name || "",
    mobile_number: (isBilling ? billingAddress : shippingAddress)?.mobile_number || "",
    email_id: (isBilling ? billingAddress : shippingAddress)?.email_id || "",
    addressType: (isBilling ? billingAddress : shippingAddress)?.addressType || "Home",
    main_street: (isBilling ? billingAddress : shippingAddress)?.main_street || "",
    city: (isBilling ? billingAddress : shippingAddress)?.city || "",
    state: (isBilling ? billingAddress : shippingAddress)?.state || "",
    house_number: (isBilling ? billingAddress : shippingAddress)?.house_number || "",
    postal_code: (isBilling ? billingAddress : shippingAddress)?.postal_code || "",
    country: (isBilling ? billingAddress : shippingAddress)?.country || "",
    landmark: (isBilling ? billingAddress : shippingAddress)?.landmark || "",
    isDefault: false,
  });

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isBilling) {
        dispatch(setBillingAddress(address));
      } else {
        dispatch(setShippingAddress(address));
        dispatch(setBillingAddress(address)); 

        // Call API to add the new address
        const resultAction = await dispatch(addNewAddress(address));

        if (addNewAddress.fulfilled.match(resultAction)) {
          // Only add the address to Redux if API call is successful
          dispatch(addNewAddress(resultAction.payload));
        } else {
          console.error("Failed to add address:", resultAction.payload);
        }
      }
      onClose(); // Close popup after saving
    } catch (error) {
      console.error("Error saving address:", error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-30 overflow-y-scroll">
      <div className="bg-tertiary p-11 md:p-6 rounded md:w-[60%] relative top-24 lg:top-7">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-center w-full">
            {isBilling ? "Add Billing Address" : "Add Shipping Address"}
          </h2>
          <FaTimes onClick={onClose} className="text-xl cursor-pointer" />
        </div>
        <hr className="mb-4" />
        <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Input Fields */}
          {[
            { label: "NAME", name: "first_name", type: "text" },
            { label: "LAST NAME", name: "last_name", type: "text" },
            { label: "E-MAIL", name: "email_id", type: "email" },
            { label: "PHONE", name: "mobile_number", type: "tel" },
          ].map((field, index) => (
            <div key={index} className="-my-1">
              <input
                id={field.name}
                name={field.name}
                type={field.type}
                value={address[field.name] || ""}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
                placeholder={field.name}
              />
              <label
                htmlFor={field.name}
                className="relative left-3 px-2 bg-tertiary text-primary1 font-outfit text-sm font-medium pointer-events-none transform -translate-y-4 scale-75 bottom-[80%] z-10 origin-[0]"
              >
                {field.label}
              </label>
            </div>
          ))}

          {/* Save Address As Dropdown */}
          <div className="lg:col-span-1 gap-4">
            <div className="-my-1 relative">
              <select
                id="addressType"
                name="addressType"
                value={address.addressType}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary appearance-none"
              >
                <option value="Home">Home</option>
                <option value="Work">Work</option>
                <option value="Other">Other</option>
              </select>
              <label
                htmlFor="addressType"
                className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-lg font-medium pointer-events-none transform -translate-y-4 scale-75 bottom-[30%] z-10 origin-[0]"
              >
                SAVE ADDRESS AS
              </label>
            </div>
          </div>

          {/* Other Address Type Input Field (Only Visible When "Other" is Selected) */}
          {address.addressType === "Other" && (
            <div className="-my-1 mb-4 relative">
              <input
                type="text"
                name="otherAddressType"
                value={address.otherAddressType || ""}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
                placeholder=" "
              />
              <label
                htmlFor="otherAddressType"
                className="absolute left-3 px-2 bg-tertiary text-primary1 font-outfit text-lg font-medium pointer-events-none transform -translate-y-4 scale-75 bottom-[30%] z-10 origin-[0]"
              >
                SPECIFY OTHER ADDRESS TYPE
              </label>
            </div>
          )}

          {/* Address Fields */}
          {[
            { label: "HOUSE/FLAT/BLOCK NUMBER", name: "house_number", type: "text" },
            { label: "MAIN STREET", name: "main_street", type: "text" },
            { label: "LANDMARK", name: "landmark", type: "text" },
            { label: "CITY", name: "city", type: "text" },
            { label: "STATE", name: "state", type: "text" },
            { label: "POSTAL CODE", name: "postal_code", type: "text" },
            { label: "COUNTRY", name: "country", type: "text" },
          ].map((field, index) => (
            <div key={index} className="-my-1">
              <input
                id={field.name}
                name={field.name}
                type={field.type}
                value={address[field.name] || ""}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
                placeholder={field.name}
              />
            </div>
          ))}

          {/* Submit Button */}
          <div className="lg:col-span-2 lg:flex justify-center gap-4 -mt-2">
            <button type="submit" className="w-full py-2 bg-hcolor text-tertiary hover:border-2 hover:text-hcolor hover:bg-tertiary transition">
              {isBilling ? "UPDATE BILLING ADDRESS" : "UPDATE SHIPPING ADDRESS"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddressPopup;
